/**
 * @generated SignedSource<<0bb7716660d4602799b0a763d0a653cf>>
 * @relayHash b79d01d1417dd5ebf35e9e6ce7e430a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7febdf10a70f7001516fe01753aeea30c50d464b1f2371636cb48600d3aaf387

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getCompassComponentsScorecardsQuery$variables = {
  componentId: string;
};
export type getCompassComponentsScorecardsQuery$data = {
  readonly compass: {
    readonly component: {
      readonly __typename: "CompassComponent";
      readonly name: string;
      readonly scorecards: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly scorecardScore: {
          readonly maxTotalScore: number;
          readonly totalScore: number;
        } | null | undefined;
      }> | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type getCompassComponentsScorecardsQuery = {
  response: getCompassComponentsScorecardsQuery$data;
  variables: getCompassComponentsScorecardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "componentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "componentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "concreteType": "CompassScorecard",
      "kind": "LinkedField",
      "name": "scorecards",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v3/*: any*/),
        {
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "componentId",
                  "variableName": "componentId"
                }
              ],
              "kind": "ObjectValue",
              "name": "query"
            }
          ],
          "concreteType": "CompassScorecardScore",
          "kind": "LinkedField",
          "name": "scorecardScore",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "totalScore"
            },
            {
              "kind": "ScalarField",
              "name": "maxTotalScore"
            }
          ]
        }
      ]
    }
  ],
  "type": "CompassComponent"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getCompassComponentsScorecardsQuery",
    "selections": [
      {
        "concreteType": "CompassCatalogQueryApi",
        "kind": "LinkedField",
        "name": "compass",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "component",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getCompassComponentsScorecardsQuery",
    "selections": [
      {
        "concreteType": "CompassCatalogQueryApi",
        "kind": "LinkedField",
        "name": "compass",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "component",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7febdf10a70f7001516fe01753aeea30c50d464b1f2371636cb48600d3aaf387",
    "metadata": {},
    "name": "getCompassComponentsScorecardsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1f4b6300c590b864105e7550b7750dd7";

export default node;
